import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import Link from "@mui/icons-material/Link";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { ContentContainer as HXContentContainer, Parent as HXParent, LighterText, Subtitle } from "./HXMobilePage.styles";
import { multilineEllipsis } from "./base.styles";
import { FlexColumn, FlexRow, HorizontalDivider } from "./common.styles";
import { HXMobileButton } from "./HXButton";
export const Parent = styled(HXParent) `
    margin-top: 0;
`;
export const SectionTitle = styled(Subtitle) `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const ZeroStateCardContainer = styled(FlexColumn) `
    background: ${colors.white_main};
    border: 1px solid ${colors.blue_10};
    border-radius: 24px;
    padding: 20px;
    gap: 12px;
    align-items: center;
    text-align: center;
`;
export const ZeroStateIconWrapper = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background-color: ${colors.blue_10};
    color: ${colors.blue_main};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    align-self: center;

    & > * {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
const BaseZeroStateIcon = css `
    width: 36px;
    height: 36px;
    color: ${colors.blue_50};
`;
export const ZeroStateIconLink = styled(Link) `
    ${BaseZeroStateIcon}
`;
export const ZeroStateCardTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    letter-spacing: 0.15px;
    line-height: normal;
    color: ${colors.black_lighter};
    width: 100%;
`;
export const ZeroStateCardDescription = styled(LighterText) `
    font-size: ${fontSizes.LITTLE};
    line-height: normal;
    color: ${colors.black_lighter};
    width: 100%;
    white-space: pre-wrap;
`;
export const SectionBlock = styled(FlexColumn) `
    gap: 12px;
    align-self: stretch;
`;
export const ContentContainer = styled(HXContentContainer) `
    padding: 20px 0 16px 0;
`;
export const SHLLinkList = styled(FlexColumn) `
    background: ${colors.white_main};
    border: 1px solid ${colors.blue_10};
    border-radius: 12px;
    overflow: hidden;
`;
export const SHLLinkRow = styled(FlexRow) `
    padding: 12px;
    gap: 16px;
    align-items: center;
    cursor: pointer;
`;
export const SHLLinkIcon = styled(FlexRow) `
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background-color: ${colors.blue_10};
    color: ${colors.navy_main};
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    align-self: center;

    & > * {
        width: 20px;
        height: 20px;
    }
`;
export const SHLLinkText = styled(FlexColumn) `
    flex: 1;
    min-width: 0;
    gap: 2px;
`;
export const SHLLinkTitle = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    ${multilineEllipsis(2)}
`;
export const SHLLinkDescription = styled(LighterText) `
    font-size: ${fontSizes.LITTLE};
    color: ${colors.black_light};
    ${multilineEllipsis(2)}
`;
export const SHLLinkStatusLine = styled.div `
    font-size: ${fontSizes.LITTLE};
    color: ${({ $active }) => ($active ? colors.forest_main : colors.black_lighter)};
`;
export const SHLLinkChevron = styled.div `
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const ArrowForwardIosIcon = styled(ArrowForwardIos) `
    color: ${colors.navy_main};
    width: 20px;
    height: 20px;
    opacity: 0.7;
`;
export const SHLRowDivider = styled(HorizontalDivider) `
    border-color: ${colors.blue_10};
`;
export const InactiveLinksSection = styled(FlexColumn) `
    background: ${colors.white_main};
    border: 1px solid ${colors.blue_10};
    border-radius: 12px;
    overflow: hidden;
`;
export const InactiveLinksHeader = styled(FlexRow) `
    padding: 12px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    gap: 8px;

    & > span:first-child {
        font-size: ${fontSizes.MEDIUM};
        font-weight: ${fontWeights.SEMI_BOLD};
        color: ${colors.black_main};
    }
`;
export const PatientListDate = styled(LighterText) `
    font-size: ${fontSizes.SMALL};
    letter-spacing: 0.17px;
`;
export const UpdateYourRecords = styled(FlexColumn) `
    padding: 16px;
    border-radius: 12px;
    background-color: ${colors.blue_5};
    justify-content: center;
    align-items: flex-start;
`;
export const PatientListOrgLogoContainer = styled(FlexRow) `
    width: 36px;
    height: 36px;
    align-self: center;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid ${colors.blue_10};
`;
export const PatientListOrgLogoImg = styled.img.attrs({ width: "100%", height: "100%" }) `
    object-fit: contain;
`;
export const PillTabsContainer = styled(FlexRow) `
    padding: 8px;
    width: 100%;
    box-sizing: border-box;
`;
export const PillTabsTrack = styled(FlexRow) `
    border: 0.63px solid ${colors.separator_main};
    border-radius: 500px;
    padding: 3px 4px 4px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: ${colors.history_surface_bg};
`;
const BasePillTab = css `
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 0;
    border-radius: 500px;
    font-size: ${fontSizes.SMALL};
    line-height: 21.5px;
    letter-spacing: -0.15px;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    border: none;
    outline: none;
    background: transparent;
`;
export const PillTabActive = styled.button `
    ${BasePillTab}
    background: ${colors.white_main};
    border: 0.37px solid rgba(0, 0, 0, 0.12);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.11), 0px 4px 2px rgba(0, 0, 0, 0.09), 0px 9px 2.5px rgba(0, 0, 0, 0.06),
        0px 15px 3px rgba(0, 0, 0, 0.02);
    font-weight: ${fontWeights.BOLD};
    color: ${colors.navy_light};
`;
export const PillTabInactive = styled.button `
    ${BasePillTab}
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_lighter};
`;
export const ConnectionsZeroStateContainer = styled(FlexColumn) `
    padding: 24px 16px;
    gap: 10px;
    align-items: flex-start;
`;
export const ConnectionsZeroStateTitle = styled.h2 `
    margin: 0;
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 31px;
    letter-spacing: 0.26px;
`;
export const ConnectionsZeroStateDescription = styled.p `
    margin: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
    line-height: 24px;
    letter-spacing: -0.31px;
`;
const connectionBannerAspectRatio = "402 / 185";
export const ConnectionsSectionHeader = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 24px 16px 16px;
    align-self: stretch;
    box-sizing: border-box;
`;
export const ConnectionsCardGrid = styled.div `
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 0 16px;
    align-self: stretch;
    box-sizing: border-box;
`;
export const AvailablePartnersDisclaimer = styled.p `
    margin: 0;
    padding: 16px 16px 0;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
    line-height: 20px;
    letter-spacing: -0.15px;
`;
export const ConnectionCard = styled.div `
    background: ${colors.white_main};
    border: 0.37px solid ${colors.separator_main};
    border-radius: 8px;
    min-height: 180px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    cursor: pointer;
`;
export const ConnectionCardCircularLogoBanner = styled.div `
    flex-shrink: 0;
    background: ${colors.connection_banner_bg};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 8px;
    box-sizing: border-box;
    aspect-ratio: ${connectionBannerAspectRatio};
`;
export const ConnectionCardBannerCircularImg = styled.img `
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
`;
export const ConnectionCardRectangularLogoBanner = styled.div `
    flex-shrink: 0;
    background: ${colors.connection_banner_bg};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    aspect-ratio: ${connectionBannerAspectRatio};
`;
export const ConnectionCardBannerRectangularImg = styled.img `
    max-width: 100%;
    min-height: 100%;
    object-fit: contain;
`;
export const ConnectionCardBody = styled(FlexColumn) `
    padding: 8px 16px 16px;
    gap: 8px;
    flex: 1;
    min-height: 0;
    justify-content: space-between;
`;
export const ConnectionCardTitle = styled.p `
    margin: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 21px;
    letter-spacing: -0.31px;
    ${multilineEllipsis(2)}
`;
export const ConnectionCardSubtitle = styled.p `
    margin: 0;
    font-size: ${fontSizes.MICRO};
    font-weight: ${fontWeights.NORMAL};
    color: ${({ $isError }) => ($isError ? colors.measurement_abnormal : colors.black_lighter)};
    line-height: 14px;
    letter-spacing: 0.12px;
    ${multilineEllipsis(2)}
`;
export const AvailableConnectButton = styled(HXMobileButton).attrs({ secondary: true }) `
    height: 28px;
    border: 1.37px solid ${colors.navy_light};
    color: ${colors.navy_light};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    line-height: 18px;
    margin-top: 16px;

    .MuiButton-endIcon {
        margin-left: 4px;
        color: ${colors.black_lighter};

        svg {
            font-size: 16px;
        }
    }
`;
export const SharedLinksContainer = styled(SectionBlock) `
    padding: 0 16px;
`;
